export type Environment = 'development' | 'staging' | 'production';

export default function getEnvironment(): Environment {
    if (process.env.NODE_ENV === 'development') return 'development';

    switch (window.location.hostname) {
        case 'secure.e-conomic.com':
        case 'secure2.e-conomic.com':
            return 'production';

        case 'internal.secure.e-conomic.com':
        case 'staging.secure.e-conomic.com':
        case 'f1.secure.e-conomic.com':
        case 'f2.secure.e-conomic.com':
        case 'plex.secure.e-conomic.com':
            return 'staging';

        default:
            return 'development';
    }
}
